import type { SVGProps } from "react";

/**
 * Razorpay's lightning-bolt mark as a plain icon, sized like a lucide icon so
 * it sits in the sidebar (TAB_ICON_MAP) and in buttons next to lucide glyphs.
 * Brand blue by default; pass `color="currentColor"` to inherit.
 */
export default function RazorpayGlyph({
  color = "#3395FF",
  ...props
}: SVGProps<SVGSVGElement> & { color?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      width="1em"
      height="1em"
      aria-hidden
      fill={color}
      {...props}
    >
      <path d="M22.346 0L13.84 8.07l-1.45 5.04L21.49 4.97 12.6 32h5.65L26.55 0h-4.2zM10.41 13.85l1.34-4.65L3 16.43 0 27l7.41-6.71L4.74 32h5.65l3.73-12.84-3.71-5.31z" />
    </svg>
  );
}
